import { render, staticRenderFns } from "./SettingsUploadSkroutzLinks.vue?vue&type=template&id=036dfb34&scoped=true"
import script from "./SettingsUploadSkroutzLinks.vue?vue&type=script&lang=js"
export * from "./SettingsUploadSkroutzLinks.vue?vue&type=script&lang=js"
import style0 from "./SettingsUploadSkroutzLinks.vue?vue&type=style&index=0&id=036dfb34&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "036dfb34",
  null
  
)

export default component.exports